
  import jsonp from 'jsonp';
import axios from 'axios';
import * as utils from '@/utils';

const objToAjaxParams = (data) => {
  let txtArr = [];
  for (let key in data) {
    txtArr.push(`${key}=${data[key]}`);
  }
  txtArr.push('callback');
  return txtArr.join('&');
};

export const getJSON = (url, data = {}) => {
  return new Promise((resolve) => {
    jsonp(
      url,
      {
        param: objToAjaxParams({
          ...data,
          cid: utils.getUrlParams('cid'),
          scid: utils.getUrlParams('scid'),
        }),
        prefix: 'jsonpCallback',
      },
      (err, res) => {
        resolve(res);
      },
    );
  });
};

export const get = (url, data) => {
  return new Promise((resolve) => {
    axios
      .get(url, {
        params: data || {},
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        resolve(res.data);
      });
  });
};

export const post = (url, data, responseType = 'json') => {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url,
      data: data,
      responseType,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        resolve(res.data || {});
      });
  });
};
